"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _reactHooks = require("@trycourier/react-hooks");

var _reactProvider = require("@trycourier/react-provider");

var useLocalStorageMessages = function useLocalStorageMessages(_ref) {
  var clientKey = _ref.clientKey,
      userId = _ref.userId;

  var _useCourier = (0, _reactProvider.useCourier)(),
      localStorage = _useCourier.localStorage;

  var _useInbox = (0, _reactHooks.useInbox)(),
      lastMessagesFetched = _useInbox.lastMessagesFetched,
      messages = _useInbox.messages,
      pinned = _useInbox.pinned,
      startCursor = _useInbox.startCursor,
      unreadMessageCount = _useInbox.unreadMessageCount;

  (0, _react.useEffect)(function () {
    if (!localStorage) {
      return;
    } // remove old 1.X LS Key


    localStorage.removeItem("".concat(clientKey, "/").concat(userId, "/messages"));
  }, [clientKey, userId, localStorage]);
  var localStorageKey = (0, _react.useMemo)(function () {
    if (!clientKey || !userId) {
      return;
    }

    return "".concat(clientKey, "/").concat(userId, "/inbox");
  }, [clientKey, userId]);
  var localStorageState = (0, _react.useMemo)(function () {
    if (!localStorageKey || !localStorage) {
      return;
    }

    try {
      var item = localStorage.getItem(localStorageKey);
      return item ? JSON.parse(item) : {};
    } catch (_unused) {// do nothing
    }
  }, [localStorageKey, localStorage]);
  (0, _react.useEffect)(function () {
    if (!localStorageKey || !localStorage) {
      return;
    }

    localStorage.setItem(localStorageKey, JSON.stringify({
      lastMessagesFetched: lastMessagesFetched,
      messages: messages,
      pinned: pinned,
      startCursor: startCursor,
      unreadMessageCount: unreadMessageCount
    }));
  }, [lastMessagesFetched, localStorage, localStorageKey, messages, pinned, startCursor, unreadMessageCount]);
  return localStorageState;
};

var _default = useLocalStorageMessages;
exports["default"] = _default;